import { NgModule } from '@angular/core';
import { BrandComponent } from './brand.component';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [BrandComponent],
  imports: [CommonModule, HttpClientModule],
  exports: [BrandComponent],
})
export class BrandModule {}
